import { IRioModelErrors } from "../../apiModels/IModelErrors";

export class ApiResponse<T> {
    success: boolean;
    statusCode: number;
    item?: T;
    errors: IRioModelErrors;
}